function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignNoEntryEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "No_x5F_Entry_x5F_EU",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 48,
    cy: 48,
    r: 46
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B33229"
    },
    cx: 48,
    cy: 48,
    r: 44
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 41,
    style: {
      fill: "#FFFFFF"
    },
    width: 78,
    height: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignNoEntryEu);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_no_entry_eu.8c932d012c80589e66f8f465f7e4a2a3.svg";
export { ForwardRef as ReactComponent };